import { InjectionToken } from '@angular/core';

/**
 * Injection token for application namespace identifier.
 * Used to determine app-specific translation overrides.
 *
 * @example
 * provideZopI18n('zopup')    // No overrides
 * provideZopI18n('inflewz')  // Loads overrides/en.json
 * provideZopI18n('verified') // Loads overrides with kn.json support
 */
export const APP_I18N_NAMESPACE = new InjectionToken<string>(
  'APP_I18N_NAMESPACE',
  {
    providedIn: 'root',
    factory: () => 'zopup', // Default to Zopup (no overrides)
  }
);

/**
 * Optional: Override detection configuration
 */
export interface I18nOverrideConfig {
  namespace: string;
  hasOverrides: boolean;
  additionalLangs?: string[]; // For verified app (kn)
}

export const APP_I18N_OVERRIDE_CONFIG = new InjectionToken<I18nOverrideConfig>(
  'APP_I18N_OVERRIDE_CONFIG'
);
